import {
  createMigrate,
  type MigrationManifest,
  type PersistedState,
} from 'redux-persist';

/**
 * Migration manifest for redux-persist.
 * Each key is a version number, and the function transforms state FROM the previous version TO that version.
 * These migrations ONLY run when the persisted version is LESS than the target version.
 */
const migrationManifest: MigrationManifest = {
  // Migration from v1 to v2: Reset layout state to use fresh default template
  // This fixes ID mismatch issues when users had old state with different widget IDs
  // This ONLY runs for users upgrading from v1 (or no version) to v2
  2: state => {
    if (state && typeof state === 'object') {
      const {
        sections: _sections,
        blocks: _blocks,
        widgetInstances: _widgetInstances,
        regions: _regions,
        template: _template,
        ...rest
      } = state as Record<string, unknown>;
      return rest as PersistedState;
    }
    return state;
  },
  // v3: the widget/layout system was removed (TMDXNC-45). Drop its persisted
  // keys so autoMergeLevel2 stops merging them back into state.
  3: state => {
    if (state && typeof state === 'object') {
      const {
        sections: _sections,
        blocks: _blocks,
        widgetInstances: _widgetInstances,
        regions: _regions,
        template: _template,
        toolbar: _toolbar,
        ...rest
      } = state as Record<string, unknown>;
      return rest as PersistedState;
    }
    return state;
  },
};

/**
 * Create the migration function using redux-persist's createMigrate.
 * This ensures migrations only run when the persisted version is less than the current version,
 * NOT on every rehydration.
 */
export const migrate = createMigrate(migrationManifest, { debug: false });
